import Overview from "./Overview";
import NonDeveloper from "./NonDeveloper";
import Developer from "./Developer";
import NativeMobile from "./NativeMobile";
import Deployment from "./Deployment";
import Hosting from "./Hosting";

export default { Overview, NonDeveloper, Developer, NativeMobile, Deployment, Hosting };
